import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=37501cd9&"
import script from "./SocialNetworks.vue?vue&type=script&lang=js&"
export * from "./SocialNetworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VContainer,
  VFlex,
  VLayout,
  VProgressCircular,
})
